import React, { useState } from 'react'

import {
  withdrawingHistory,
  withdrawingHistoryHeadings,
  withdrawingHistoryTabs,
} from '../../../../../constants'

const WithdrawingHistory = () => {
  const [activeTab, setActiveTab] = useState(withdrawingHistoryTabs[0].value)

  const withdrawingHistoryTabsContent = withdrawingHistoryTabs.map((withdrawingHistoryTab) => {
    const isActive = activeTab === withdrawingHistoryTab.value

    return (
      <button
        key={withdrawingHistoryTab.value}
        className={`text-base text-primary-100 transition-opacity duration-200 ease ${isActive ? 'font-bold opacity-100' : 'font-medium opacity-70'}`}
        onClick={() => setActiveTab(withdrawingHistoryTab.value)}
      >
        {withdrawingHistoryTab.label}
      </button>
    )
  })

  const withdrawingHistoryHeadingsContent = withdrawingHistoryHeadings.map(
    (withdrawingHistoryHeading, index) => {
      return (
        <th
          key={withdrawingHistoryHeading}
          className={`py-[12px] px-[24px] rounded-t-[10px] text-xs font-medium text-primary-100 ${index === withdrawingHistoryHeadings.length - 1 || index === withdrawingHistoryHeadings.length - 2 ? 'text-right' : 'text-left'}`}
        >
          {withdrawingHistoryHeading}
        </th>
      )
    }
  )

  const withdrawingHistoryContent = withdrawingHistory.map((withdrawingHistoryRow, index) => {
    return (
      <tr
        key={withdrawingHistoryRow.id}
        className={`w-full ${index === withdrawingHistory.length - 1 ? '' : 'border-b-[#EAECF0] border-b-[1px]'}`}
      >
        <td className="py-[8px] px-[24px] text-sm text-primary-100">
          {withdrawingHistoryRow.date}
        </td>

        <td className="py-[8px] px-[24px] text-sm text-primary-100">
          {withdrawingHistoryRow.description}
        </td>

        <td className="py-[8px] px-[24px]">
          <div className="w-full flex items-center justify-end">
            <img src={withdrawingHistoryRow.icon} alt="" className="w-[24px] h-[24px] mr-[8px]" />

            <span className="text-sm text-primary-100 text-end">
              {withdrawingHistoryRow.amount}
            </span>
          </div>
        </td>

        <td className="py-[8px] px-[24px]">
          <div className="w-full flex items-center justify-end">
            <img src={withdrawingHistoryRow.icon} alt="" className="w-[24px] h-[24px] mr-[8px]" />

            <span className="text-sm text-primary-100 text-end">
              {withdrawingHistoryRow.balance}
            </span>
          </div>
        </td>
      </tr>
    )
  })

  return (
    <div className="w-full mt-[24px]">
      <div className="w-full flex items-center gap-x-[20px]">{withdrawingHistoryTabsContent}</div>

      <table className="border-collapse w-full bg-white mt-[10px] rounded-[10px]">
        <thead>
          <tr className="w-full bg-[#FDFDFD]">{withdrawingHistoryHeadingsContent}</tr>
        </thead>
        <tbody>{withdrawingHistoryContent}</tbody>
      </table>
    </div>
  )
}

export default WithdrawingHistory
